<template>

  <filter-panel
    class="filters-panel"
    :apply-filter-immediately="false"
    :filter-parameters="formattedFilters"
    @update="applyFilter"
    :notification-text="null"
    :api-request-data="null"/>

</template>

<script>
import getNested from 'lodash-es/get';
import { mapGetters } from 'vuex';
import FilterPanel from '../widgets/FilterPanel';
import {
  getAPIFilterValues,
  applyFilterValues,
} from '../widgets/FilterPanel';

export default {
  name: 'filters',

  components: {
    FilterPanel,
  },

  data() {
    const defaultChoices = {
      zone: [{text: '-- Zone --', value: null}],

      // period: {text: '-- Period type --', value: null},
      // segment: [{text: 'Capesize', value: 'capesize'}],
      // direction: [{text: 'NNE', value: 'NNE'}],
      // ladenStatus: [{text: 'Laden', value: 'Laden'}],
    };

    return {
      filtersReady: true,

      // select fields
      filterSchema: {
        percentage: {
          name: 'percentage',
          apiName: 'percentage',
          type: 'switch',
          label: 'Percentage',
          value: false,
          defaultChoice: false,
        },

        miniCharts: {
          name: 'miniCharts',
          apiName: 'miniCharts',
          type: 'switch',
          label: 'Show mini charts',
          value: false,
          defaultChoice: false,
        },

        segment: {
          name: 'segment',
          apiName: 'segment',
          type: 'multiselect',
          placeholder: 'segment',
          value: [],
          choices: [
            {text: 'Capesize', value: 'capesize'},
            {text: 'Handysize', value: 'handysize'},
            {text: 'Panamax', value: 'panamax'},
            {text: 'Supramax', value: 'supramax'},
          ],
          defaultChoice: defaultChoices.segment,
        },

        direction: {
          name: 'direction',
          apiName: 'direction',
          type: 'multiselect-direction',
          placeholder: 'Direction',
          value: [],
          choices: [
            {text: 'NNE', value: 'NNE'},
            {text: 'ENE', value: 'ENE'},
            {text: 'ESE', value: 'ESE'},
            {text: 'SSE', value: 'SSE'},
            {text: 'SSW', value: 'SSW'},
            {text: 'WSW', value: 'WSW'},
            {text: 'WNW', value: 'WNW'},
            {text: 'NNW', value: 'NNW'},
          ],
          defaultChoice: defaultChoices.direction,
        },

        ladenStatus: {
          name: 'ladenStatus',
          apiName: 'ladenStatus',
          type: 'multiselect',
          placeholder: 'Laden status',

          value: [
            {text: 'Laden', value: 'Laden'},
            {text: 'Ballast', value: 'Ballast'},
          ],
          choices: [
            {text: 'Laden', value: 'Laden'},
            {text: 'Ballast', value: 'Ballast'},
          ],
          defaultChoice: defaultChoices.ladenStatus,
        },

        portStatus: {
          name: 'portStatus',
          apiName: 'portStatus',
          type: 'multiselect',
          placeholder: 'Port Status',

          value: [],
          choices: [
            {text: 'In Port', value: 'in_port'},
            {text: 'At Sea', value: 'at_sea'},
          ],
          defaultChoice: defaultChoices.portStatus,
        },

        period: {
          name: 'period',
          apiName: 'period',
          type: 'select-buttons',
          label: 'Day range:',

          value: 7,  // override default choice
          choices: [
            // defaultChoices.period,
            {text: 'Past 7 days', value: 7},
            {text: 'Past month', value: 30},
            {text: 'Past 90 days', value: 90},
            {text: 'Past year', value: 365},
          ],
          // defaultChoice: defaultChoices.period.value,
        },
      },  // <-- filterParameters end
    };
  },

  methods: {
    async applyFilter(filterValues) {
      if(!this.filtersReady) {
        return;
      }

      applyFilterValues(this.filterSchema, filterValues);
      this.$emit('search', getAPIFilterValues(this.filterSchema, filterValues));
    },
  },

  computed: {
    ...mapGetters('api/presets', ['getActivePreset']),

    formattedFilters() {
      return {
        groups: [
          [
            this.filterSchema.percentage,
            this.filterSchema.segment,
          ],
          [
            this.filterSchema.direction,
            this.filterSchema.ladenStatus,
            this.filterSchema.period,
            this.filterSchema.miniCharts,
          ],
        ],
      };
    },
  },

  watch: {
    getActivePreset: {
      immediate: true,
      handler: function(preset) {
        if(preset && this.$route.path !== preset.viewName) {
          return;
        }

        if(preset) {
          // filter panel will be updated by props values and .applyFilter() will be emitted
          applyFilterValues(this.filterSchema, getNested(preset, 'params.filterPanel', {}));
        }
      },
    }
  },
}
</script>


<style scoped>
.filters-panel >>> .multiselect__tags {
  min-width: 300px;
}
</style>
